import { UserActionHistoryService } from "../../services/UserActionHistoryService.js";

export class ContextModalBodyAdditionalObjectCubeComponentController {
    
    static $inject = [ "$scope" ];

    actStack = UserActionHistoryService.getInstance();

    constructor( $scope ) {

        this.$scope = $scope;

        $scope.data = null;
        $scope.obj  = null;

        $scope._val_w    = undefined;
        $scope._val_h    = undefined;
        $scope._val_d    = undefined;
        $scope._val_clr = undefined;
        $scope._val_z    = undefined;
    }

    $onInit() {
        let { $scope, data } = this;

        let obj  = data.obj;
        let opts = obj.opts;

        $scope.data = data;
        $scope.obj  = obj;

        $scope._val_w   = opts.width  * 100;
        $scope._val_h   = opts.height * 100;
        $scope._val_d   = opts.depth  * 100;
        $scope._val_clr = opts.color;
        $scope._val_z   = obj.z_offset * 100;
    }

    get width() { return this.$scope._val_w; }
    set width( value_cm ) {
        this.actStack.do( 'additionalObject.cube.setSize', this.data.obj, value_cm / 100, null, null );
        this.$scope._val_w = this.data.obj.opts.width * 100
    }

    get height() { return this.$scope._val_h; }
    set height( value_cm ) {
        this.actStack.do( 'additionalObject.cube.setSize', this.data.obj, null, value_cm / 100, null );
        this.$scope._val_h = this.data.obj.opts.height * 100
    }

    get depth() { return this.$scope._val_d; }
    set depth( value_cm ) {
        this.actStack.do( 'additionalObject.cube.setSize', this.data.obj, null, null, value_cm / 100 );
        this.$scope._val_d = this.data.obj.opts.depth * 100
    }

    get z_offset() { return this.$scope._val_z; }
    set z_offset( value_cm ) {
        this.actStack.do( 'additionalObject.setZOffset', this.data.obj, value_cm / 100 );
        this.$scope._val_z = this.data.obj.z_offset * 100
    }

    get texture_color() { return this.$scope._val_clr; }
    set texture_color( value_hex ) {
        this.actStack.do( 'additionalObject.cube.setColor', this.data.obj, value_hex );
        this.$scope._val_clr = this.data.obj.opts.color
    }

    available_plane_keys = {
        wall:  { i18n_key: "plane_wall"  },
        floor: { i18n_key: "plane_floor" }
    };

    toggle_available_plane( key ) {

        if (!this.available_plane_keys[key]) return;

        let { obj } = this.data;

        if (!obj.availPlanes) obj.availPlanes = {};

        obj.availPlanes[ key ]  = !obj.availPlanes[ key ];
    }
}

export class ContextModalBodyAdditionalObjectPlaneComponentController extends ContextModalBodyAdditionalObjectCubeComponentController {
    static $inject = [ "$scope" ];

    constructor( $scope ) {
        super( $scope );
    }

    $onInit() {
        super.$onInit();
    }
}

export class ContextModalBodyAdditionalObjectTextComponentController extends ContextModalBodyAdditionalObjectPlaneComponentController {

    static $inject = [ "$scope" ];

    constructor( $scope ) {
        super( $scope );

        $scope._val_text         = undefined;
        $scope._val_text_clr     = undefined;
        $scope._val_bg_clr       = undefined;
        $scope._val_font         = undefined;
        $scope._val_font_size_px = undefined;
        $scope._val_text_height  = undefined;
    }

    $onInit() {
        super.$onInit();

        let { $scope, data } = this;

        let obj = data.obj;
        let opts = obj.opts;

        $scope._val_text = opts.text;
        
        $scope._val_text_clr     = $scope._val_clr;
        $scope._val_bg_clr       = $scope._val_clr;

        $scope._val_font         = undefined;

        $scope._val_font_size_px = opts.font_size_px;
        $scope._val_text_height  = opts.text_height;
    }

    get font_size_px() { return this.$scope._val_font_size_px; }
    set font_size_px( font_size_px ) {
        this.data.obj.opts.font_size_px = font_size_px;
        //this.actStack.do( 'additionalObject.text.setFontSizePx', this.data.obj, font_size_px );
        this.data.obj.updateMeshMaterial();
        this.$scope._val_font_size_px = font_size_px;
    }

    get text() { return this.$scope._val_text; }
    set text( text ) {
        this.data.obj.opts.text = text;
        //this.actStack.do( 'additionalObject.text.setText', this.data.obj, text );
        this.data.obj.updateMeshMaterial();
        this.$scope._val_text = text;
    }

    get text_height() { return this.$scope._val_text_height; }
    set text_height( text_height ) {
        this.data.obj.opts.text_height = text_height;
        //this.actStack.do( 'additionalObject.text.setTextHeight', this.data.obj, text_height );
        this.data.obj.updateMeshMaterial();
        this.$scope._val_text_height = text_height;
    }
}

export const ContextModalBodyAdditionalObjectTextComponent = {

    selector: "context-modal-body-additional-object-text",
    name: "contextModalBodyAdditionalObjectText",

    bindings: {
        data: "="
    },

    templateUrl: "templates/context-modals/additionalObject-inner.text.html",
    controller: ContextModalBodyAdditionalObjectTextComponentController
};